import { datadogLogs } from '@datadog/browser-logs'

const TOKEN_KEY = 'token'
const FMP_API_KEY = 'fmpApiKey'

/**
 * Decoded JWT payload structure
 */
export interface DecodedToken {
    email: string
    exp: number
    iat: number
    isSubscribed: boolean
    stripeSubscriptionId: string
    userId: number
    subscriptionType: 'REGULAR' | 'PREMIUM' | 'ENTERPRISE' | null
}

/**
 * Decode a JWT token without verification (client-side only)
 */
export function decodeToken(token: string): DecodedToken | null {
    if (!token) return null

    try {
        const parts = token.split('.')
        if (parts.length !== 3) {
            console.error('Invalid token format')
            return null
        }

        const payload = parts[1]
        const decodedPayload = window.atob(payload)
        return JSON.parse(decodedPayload) as DecodedToken
    } catch (error) {
        console.error('Failed to decode token:', error)

        if (process.env.NODE_ENV === 'production') {
            datadogLogs.logger.error('Token decode error', {
                error: error instanceof Error ? error.message : String(error),
            })
        }

        return null
    }
}

/**
 * Clear all auth-related data from storage
 */
export function clearAuthStorage(): void {
    try {
        window.localStorage.removeItem(TOKEN_KEY)
        window.localStorage.removeItem(FMP_API_KEY)
    } catch (error) {
        console.error('Failed to clear auth storage:', error)
    }
}

/**
 * Sync token from Zustand store to localStorage
 */
export function syncTokenToStorage(
    token: string,
    fmpApiKey?: string | null
): void {
    try {
        if (token) {
            window.localStorage.setItem(TOKEN_KEY, token)
        } else {
            window.localStorage.removeItem(TOKEN_KEY)
        }

        if (fmpApiKey) {
            window.localStorage.setItem(FMP_API_KEY, fmpApiKey)
        }
    } catch (error) {
        console.error('Failed to sync token to storage:', error)
    }
}
